import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface FavoriteItem {
  cakeId: number
  name: string
  image: string
  price: number
  category: string
  taste: string
}

interface FavoriteStore {
  favorites: FavoriteItem[]
  toggleFavorite: (item: FavoriteItem) => void
  isFavorite: (cakeId: number) => boolean
  removeFavorite: (cakeId: number) => void
  clearAll: () => void
}

export const useFavoriteStore = create<FavoriteStore>()(
  persist(
    (set, get) => ({
      favorites: [],

      toggleFavorite: (item) => {
        const exists = get().favorites.some(f => f.cakeId === item.cakeId)
        if (exists) {
          set((state) => ({ favorites: state.favorites.filter(f => f.cakeId !== item.cakeId) }))
        } else {
          set((state) => ({ favorites: [...state.favorites, item] }))
        }
      },

      isFavorite: (cakeId) => {
        return get().favorites.some(f => f.cakeId === cakeId)
      },

      removeFavorite: (cakeId) => {
        set((state) => ({ favorites: state.favorites.filter(f => f.cakeId !== cakeId) }))
      },

      clearAll: () => set({ favorites: [] }),
    }),
    { name: 'cake-shop-favorites' }
  )
)
